import { Controller } from '@hotwired/stimulus';

export default class ChooseLegalGuardian extends Controller {
  static targets = ['link'];
  static values = { src: String };

  updateLink(event) {
    const { target } = event.detail;
    if (!(target instanceof HTMLElement)) return;
    const value = target.getAttribute('value');
    if (!value) return;

    this.showLink();
    this.linkTarget.href = this.srcValue.replace('__id__', value);
  }

  showLink() {
    this.linkTarget.hidden = false;
  }

  hideLink() {
    this.linkTarget.hidden = true;
  }
}
